import { ColonistGiftMembershipProduct } from '../../../../../shared/store/ColonistGiftMembershipProduct.ts';
import { UIStoreMembershipProductView } from '../UIStoreMembershipProductView.ts';
import { localizeMonthlyToAnnual } from '../PriceUtils.ts';
import { createDivIn, createHeaderIn, createParagraphIn, setElementInnerHTML } from '../../ui_utils/DomUtils.ts';
import { ColonistMembershipProduct } from '../../../../../shared/store/ColonistMembershipProduct.ts';
export class UIStoreGiftMembershipProductView extends UIStoreMembershipProductView {
    select() {
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.giftOverlay.tierSelection.selected'
        });
        this.productDiv.classList.add('selected');
        this.subscribeButton.classList.add('selected');
    }
    deselect() {
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.giftOverlay.tierSelection.select'
        });
        this.productDiv.classList.remove('selected');
        this.subscribeButton.classList.remove('selected');
    }
    setPrice(price) {
        const localizedProductData = this.localizedStoreProductData.find((data)=>data.productId == this.membershipProduct.mobileIAPSKUId);
        var _localizedProductData_displayPrice;
        const localizedPrice = (_localizedProductData_displayPrice = localizedProductData === null || localizedProductData === void 0 ? void 0 : localizedProductData.displayPrice) !== null && _localizedProductData_displayPrice !== void 0 ? _localizedProductData_displayPrice : undefined;
        setElementInnerHTML(this.priceDiv, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        this.membershipPrice = createHeaderIn(this.priceDiv, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, '', '', 'H1');
        setElementInnerHTML(this.membershipPrice, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: localizedPrice !== null && localizedPrice !== void 0 ? localizedPrice : `$${price}`
            }
        });
        this.disclaimerText.replaceChildren();
    }
    isAnnualGiftMembership() {
        return this.membershipProduct.discount != 0;
    }
    addBestValueHint() {
        if (!this.membershipProduct.bestValue) return;
        this.productDiv.classList.add('store_page_membership_best_value_border');
        const badge = createDivIn(this.headerDiv, 'badge-white badge-lg');
        createParagraphIn(badge, {
            key: 'strings:storePage.mostPopular'
        }, '');
    }
    showStrikeThroughPrice() {
        const monthlyPrice = ColonistMembershipProduct.getMonthlyPriceOfAnnualMembership(this.getColonistMembershipType());
        if (monthlyPrice == undefined) return;
        const monthsPerYear = 12;
        const localizedYearlyPrice = this.getLocalizedYearlyStrikethroughPrice();
        const defaultYearlyPrice = `$${parseFloat(monthlyPrice) * monthsPerYear}`;
        const yearlyPrice = localizedYearlyPrice !== null && localizedYearlyPrice !== void 0 ? localizedYearlyPrice : defaultYearlyPrice;
        const strikethroughPrice = createParagraphIn(this.priceDiv, {
            key: 'strings:storePage.sections.membership.billing.strikethrough',
            options: {
                amount: yearlyPrice
            }
        }, 'strikethrough-price', '');
        this.priceDiv.insertBefore(strikethroughPrice, this.priceDiv.firstChild);
    }
    getLocalizedYearlyStrikethroughPrice() {
        const monthlyProduct = ColonistMembershipProduct.getMonthlyProductOfAnnualMembership(this.getColonistMembershipType());
        if (monthlyProduct == undefined) return undefined;
        const monthlyGiftProduct = ColonistGiftMembershipProduct.getMembershipProduct(monthlyProduct.type);
        const localizedMonthly = this.localizedStoreProductData.find((data)=>data.productId == monthlyGiftProduct.mobileIAPSKUId);
        if ((localizedMonthly === null || localizedMonthly === void 0 ? void 0 : localizedMonthly.price) == null) return undefined;
        return localizeMonthlyToAnnual(localizedMonthly);
    }
    constructor(parentDiv, storeState, product, localizedStoreProductData){
        super(parentDiv, storeState, product), this.localizedStoreProductData = [];
        this.localizedStoreProductData = localizedStoreProductData;
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.giftOverlay.tierSelection.select'
        });
        this.subscribeButtonText.style.marginBottom = '0';
        this.setPrice(product.getDefaultPrice());
        this.subscribeButton.classList.add('button-select');
        if (this.isAnnualGiftMembership()) this.showStrikeThroughPrice();
    }
}
